/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HotelCuratedContent
 */
export interface HotelCuratedContent {
    /**
     * 
     * @type {string}
     * @memberof HotelCuratedContent
     */
    sourceName: string;
    /**
     * 
     * @type {string}
     * @memberof HotelCuratedContent
     */
    articleName?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelCuratedContent
     */
    sourceLink: string;
    /**
     * 
     * @type {string}
     * @memberof HotelCuratedContent
     */
    content?: string;
    /**
     * 
     * @type {Date}
     * @memberof HotelCuratedContent
     */
    dateReviewed?: Date;
}

/**
 * Check if a given object implements the HotelCuratedContent interface.
 */
export function instanceOfHotelCuratedContent(value: object): value is HotelCuratedContent {
    if (!('sourceName' in value) || value['sourceName'] === undefined) return false;
    if (!('sourceLink' in value) || value['sourceLink'] === undefined) return false;
    return true;
}

export function HotelCuratedContentFromJSON(json: any): HotelCuratedContent {
    return HotelCuratedContentFromJSONTyped(json, false);
}

export function HotelCuratedContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelCuratedContent {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceName': json['source_name'],
        'articleName': json['article_name'] == null ? undefined : json['article_name'],
        'sourceLink': json['source_link'],
        'content': json['content'] == null ? undefined : json['content'],
        'dateReviewed': json['date_reviewed'] == null ? undefined : (new Date(json['date_reviewed'])),
    };
}

export function HotelCuratedContentToJSON(json: any): HotelCuratedContent {
    return HotelCuratedContentToJSONTyped(json, false);
}

export function HotelCuratedContentToJSONTyped(value?: HotelCuratedContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source_name': value['sourceName'],
        'article_name': value['articleName'],
        'source_link': value['sourceLink'],
        'content': value['content'],
        'date_reviewed': value['dateReviewed'] == null ? value['dateReviewed'] : value['dateReviewed'].toISOString().substring(0,10),
    };
}

